import React from 'react';
import { useNavigate } from 'react-router-dom';

const RegistrationComplete = () => {
  const navigate = useNavigate();
  const handleExplore = () => {
    window.location.href = 'https://www.leapfrog.com';
  };

  return (
    <div className="registration-complete-page page-container">
      <div className="page-title">
        <h1>LeapFrog Lab Registration</h1>
      </div>

      <div className="registration-complete-form form-group">
        <h2 className="page-subtitle">Your registration is almost complete</h2>
        <div className="completion-text">
          <p>
            You should receive an email* that will ask you to confirm your
            registration for security purposes. Please follow the instructions
            in this email within the next 72 hours to become an active member
            for LeapFrog Lab testing.
          </p>

          <p>
            <strong>
              Thank you for taking the time to complete this process!
            </strong>
          </p>

          <p>
            * If you do not receive the confirmation email within a few minutes
            of signing up, please check your Spam / Junk mail folder. If you
            still do not receive the confirmation email, please send an email to{' '}
            <a href="mailto:leapfroglab@leapfrog.com">
              leapfroglab@leapfrog.com
            </a>{' '}
            and we will do our best to answer your request as soon as possible.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationComplete;
